import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import BylineWithHeadshot from '@components/BylineWithHeadshot';
import ProExclusiveLogo from '@components/ProExclusiveLogo';
import ProjectTitle from '@components/ProjectTitle';
import useDatawrapperResize from '@hooks/useDatawrapperResize';
import { Project, ProjectMedia } from '@interfaces/projects';
import { ACCESS_PRO } from '@src/constants';

import Media from './Media';

type TopSectionProps = Pick<
  Project,
  'accessLevel' | 'authors' | 'description' | 'title' | 'titleCallout'
> & {
  mediaSourcePath: string;
  projectMedia?: ProjectMedia[];
};

const TopSection = ({
  accessLevel,
  authors,
  description,
  mediaSourcePath,
  projectMedia,
  title,
  titleCallout,
}: TopSectionProps): JSX.Element => {
  useDatawrapperResize();

  return (
    <div className="mx-auto max-w-5xl px-16">
      {accessLevel >= ACCESS_PRO && <ProExclusiveLogo />}
      <ProjectTitle className="!mb-16" title={title} titleCallout={titleCallout} />
      {authors?.length > 0 && (
        <div className="flex justify-center">
          <BylineWithHeadshot
            authors={authors}
            className="font-suisse-screen text-byline-sm text-primary-black sm:text-byline-lg"
          />
        </div>
      )}
      {projectMedia?.length > 0 ? (
        <div className="flex flex-col flex-wrap items-center justify-between gap-40 md:mt-64 md:flex-row md:items-start">
          <div className="my-18 w-full flex-grow md:w-5/12">{ReactHtmlParser(description)}</div>
          {projectMedia.map((media) => (
            <Media key={media.id} media={media} mediaSourcePath={mediaSourcePath} />
          ))}
        </div>
      ) : (
        <div className="mt-18 mx-auto w-full md:mt-64">{ReactHtmlParser(description)}</div>
      )}
    </div>
  );
};

export default TopSection;
